import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import isEqual from "lodash/isEqual";
import PropTypes from "prop-types";
import { updateSubscribers } from "~/store/actions/actions.subscription";
import { addTask, editTask } from "~/store/actions/actions.tasks.jsx";
import { getTaskSubscriberIds } from "~/store/selectors/selector.subscription";
import TaskFormContainer from "./TaskFormContainer.jsx";

const TaskFormSubmitContainer = (props) => {
  const dispatch = useDispatch();
  const subscribers = useSelector((state) => getTaskSubscriberIds(state, props.id));

  const handleSubmit = useCallback(
    (attributes) => {
      const additional = {};

      if (!props.id && props.taskListId) {
        additional.task_list_id = props.taskListId;
      }

      if (props.id) {
        const first = [...attributes.subscribers].sort();
        const second = [...subscribers].sort();
        if (!isEqual(first, second)) {
          dispatch(updateSubscribers(props.id, "task", attributes.subscribers));
        }

        dispatch(editTask(props.projectId, props.id, attributes)).then(() => {
          props.onSubmit(attributes);
        });
      } else {
        dispatch(addTask(props.projectId, { ...additional, ...attributes }));
        props.onSubmit(attributes);
      }
    },
    [subscribers, dispatch, props]
  );

  return (
    <TaskFormContainer
      {...props}
      onSubmit={handleSubmit}
    />
  );
};

TaskFormSubmitContainer.propTypes = {
  id: PropTypes.number,
  projectId: PropTypes.number,
  taskListId: PropTypes.number,
  onSubmit: PropTypes.func,
};
TaskFormSubmitContainer.displayName = "TaskFormSubmitContainer";

export default TaskFormSubmitContainer;
